module.exports = __webpack_public_path__ + "static/5-1c987092646f3efd2679410464362838.jpeg";